// extracted by css-extract-rspack-plugin
export default {"mobileVert":"Communication_mobileVert__BkhiP"};